import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

import { GTM_LIST_LABEL } from './constants';

export const trackImpressionWithProductList = (
  products: GetProductsByIdBatchedQuery['vpProductByIds']
) => {
  dispatchTrackingEvent({
    event: 'view_item_list',
    product_lists: {
      products: products.map((product, index) =>
        ProductEventWither()
          .withVpProduct(product)
          .withAdditionalData({ list_position: index + 1 })
          .build()
      ),
      interaction: 'scroll',
      sorting_type: 'automatic',
      list_id: undefined,
      list_name: GTM_LIST_LABEL,
    },
    _clear: true,
  });
};
